import { render, staticRenderFns } from "./SettlementForm.vue?vue&type=template&id=3a3c8de9&scoped=true&"
import script from "./SettlementForm.vue?vue&type=script&lang=js&"
export * from "./SettlementForm.vue?vue&type=script&lang=js&"
import style0 from "./SettlementForm.vue?vue&type=style&index=0&id=3a3c8de9&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a3c8de9",
  null
  
)

export default component.exports